import Alert from '@/components/Alert/Alert'
import { getPlanByCode, isPlanCodeGtOther } from '@/lib/payment/plans'
import { CurrentUser } from '@/redux/slices/currentUserSlice'
import { PlanCode } from '@/typings/domain'
import { router } from 'expo-router'
import { Platform } from 'react-native'

export function showUpgradeBlockedAlertIfNeeded(currentUser?: CurrentUser): boolean {
  const status = currentUser?.billingAccount.planPackage?.planUpgradeStatus
  if (status && !status.enabled) {
    Alert.alert('提示', status.message ?? '当前套餐无法在此处升级')
    return true
  }
  return false
}

export function iosUpgradeGuard({
  recommendedPlanCode,
  currentUser,
}: {
  recommendedPlanCode?: PlanCode
  currentUser?: CurrentUser
}): boolean {
  if (showUpgradeBlockedAlertIfNeeded(currentUser)) return false

  if (recommendedPlanCode && isPlanCodeGtOther(recommendedPlanCode, PlanCode.Ent2)) {
    const planTitle = getPlanByCode(recommendedPlanCode)?.title ?? '企业版'
    Alert.alert(
      planTitle,
      `该功能仅支持「${planTitle}」套餐及以上使用\n\n企业版套餐专为团队协作设计，开通需要进行需求确认和账户配置\n\n请联系我们 support@jinshuju.net`
    )
    return false
  }

  return true
}

export function handleClickToPay({
  recommendedPlanCode,
  currentUser,
}: { recommendedPlanCode?: PlanCode; currentUser?: CurrentUser } = {}) {
  if (Platform.OS === 'ios') {
    if (!iosUpgradeGuard({ recommendedPlanCode, currentUser })) return

    router.push({
      pathname: '/profile/iosPaywall',
      params: recommendedPlanCode ? { recommendedEntitlement: recommendedPlanCode } : {},
    })
    return
  }

  if (showUpgradeBlockedAlertIfNeeded(currentUser)) return

  router.push({
    pathname: '/profile/plans',
    params: recommendedPlanCode ? { recommendedPlanCode } : {},
  })
}
